module.exports = "<h1>${this.podaci.naslov}</h1> <p class=${this.css.upute}>${this.podaci.upute}</p> <input type=text id=ime> <button type=button id=pokazi-zakletvu>${this.podaci.akcija}</button> <div class=${this.css.zakletva}> <p>${this.podaci.tekstZakletve1}</p> <p>${this.podaci.tekstZakletve2}</p> <img class=full src=${this.podaci.slika}> <div class=desno> <button class=belo>${this.podaci.akcija2}</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/komponente/zakletva/sablon.html
// module id = 37
// module chunks = 0